/**
 * @desc OMS获取逆向物流信息
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.logisticsReverseFacadeImpl.getInfo.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/logisticsReverse/getInfo`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
